import { SettingsPermissions } from "@redotech/account-common/permissions";
import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const shippingSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("Carriers");
      },
      permission: SettingsPermissions.SET_SHIPPING_SETTINGS,
    },
    path: "carriers",
    lazy: async () => {
      const { CarriersPage: Carriers } =
        await import("@redotech/redo-merchant-fulfillment-app/setting/carrier-accounts/carriers-page");
      return { Component: Carriers };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Cross border");
      },
      permission: SettingsPermissions.SET_SHIPPING_SETTINGS,
    },
    path: "cross-border",
    lazy: async () => {
      const { LoadCrossBorderSettingsPage } =
        await import("@redotech/redo-merchant-fulfillment-app/setting/cross-border");
      return { Component: LoadCrossBorderSettingsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Discounts");
      },
      permission: SettingsPermissions.SET_SHIPPING_SETTINGS,
    },
    path: "discounts",
    lazy: async () => {
      const { LoadShippingDiscountsPage } =
        await import("@redotech/redo-merchant-fulfillment-app/setting/discounts");
      return { Component: LoadShippingDiscountsPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Freight");
      },
      permission: SettingsPermissions.SET_SHIPPING_SETTINGS,
    },
    path: "freight",
    lazy: async () => {
      const { FreightPage } =
        await import("../../../../setting/freight/freight-page");
      return { Component: FreightPage };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Fulfillment promise");
      },
      permission: SettingsPermissions.SET_SHIPPING_SETTINGS,
    },
    path: "fulfillment-cutoff",
    lazy: async () => {
      const { FulfillmentCutoffPage } =
        await import("../../../../setting/fulfillment-cutoff/fulfillment-cutoff-page");
      return { Component: FulfillmentCutoffPage };
    },
  },
];
